import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useTablaStore = create(
  persist(
    (set) => ({
      sortConfig: { key: null, direction: '' },
      
      setSortConfig: (config) => set({ sortConfig: config }),
      
      resetSort: () => {
        set({ sortConfig: { key: null, direction: '' } });
      },
      
      resetTablaState: () => {
        set({ sortConfig: { key: null, direction: '' } });
        // Eliminar la bandera para que al volver se resetee
        sessionStorage.removeItem('compras_tabla_visible');
      },
    }),
    {
      name: 'compras_tabla_store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (s) => ({
        sortConfig: s.sortConfig,
      })
    }
  )
);
